import { useTranslation } from 'react-i18next';

import type { LayerState } from '@/api/generated/schemas';
import { Badge, type BadgeTone } from '@/shared/ui';
import { toSerieStateKey, type SerieStateKey } from '../../internal/serieLayers';

const STATE_TONE: Record<SerieStateKey, BadgeTone> = {
  locked: 'neutral',
  draft: 'draft',
  approved: 'info',
  published: 'success',
  changes: 'warning',
};

interface SerieStateBadgeProps {
  state: LayerState;
}

/**
 * Stavový badge vrstvy (pipeline i sloupce tabulky termínů). Jediný zdroj mapování stav → tón + lokalizovaný popis.
 */
export function SerieStateBadge({ state }: SerieStateBadgeProps) {
  const { t } = useTranslation('planner');
  const key = toSerieStateKey(state);
  return (
    <Badge tone={STATE_TONE[key]} appearance="soft">
      {t(`serieDetail.states.${key}`)}
    </Badge>
  );
}
